'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _detail = require('./detail');

var _news = require('./news');

var _includedProductsInPack = require('./components/included-products-in-pack');

var _includedProductsInPanacee = require('./components/included-products-in-panacee');

var _productDetailContent = require('./components/product-detail-content');

var _productImg = require('./components/product-img');

var _productInfo = require('./components/product-info');

var _productInfoBox = require('./components/product-info-box');

var _relatedProducts = require('./components/related-products');

var _productDiscounts = require('./components/product-discounts');

var _productFilters = require('./components/product-filters');

var _productOverview = require('./components/product-overview');

var _productOverviewToolbar = require('./components/product-overview-toolbar');

var _productOverviewGrid = require('./components/product-overview-grid');

var _productOverviewGridItem = require('./components/product-overview-grid-item');

var _panaceeOverviewGrid = require('./components/panacee-overview-grid');

var _panaceeOverviewGridItem = require('./components/panacee-overview-grid-item');

var _productOverviewList = require('./components/product-overview-list');

var _productOverviewListItem = require('./components/product-overview-list-item');

var _panaceeOverviewList = require('./components/panacee-overview-list');

var _panaceeOverviewListItem = require('./components/panacee-overview-list-item');

var _selectedFilters = require('./components/selected-filters');

var _stockResponse = require('./components/stock-response');

var _addProductsToolbar = require('./components/add-products-toolbar');

var _medipimInfo = require('./components/medipim-info');

var _productCertificatesOverviewSearch = require('./components/product-certificates-overview-search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.product', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('master.product-news', {
        url: '/products/{id:int}/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'productNews'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", function product($stateParams, productService) {
                return productService.get($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        }
    }).state('seller.product-news', {
        url: '/products/{id:int}/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'productNews'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", function product($stateParams, productService) {
                return productService.get($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        }
    }).state('general.products.product', {
        url: '/{productId:int}',
        views: {
            'main@root': {
                component: 'product'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", "$state", function product($stateParams, productService, $state) {
                return productService.get($stateParams.productId).then(function (result) {
                    if (result.type === 'RENTAL') {
                        $state.go('seller.rentProductDetail', { sellerId: result.sellerId, productId: result.id }, { reload: true });
                    } else {
                        return result;
                    }
                });
            }]
        },
        reloadOnSearch: false,
        params: {
            productId: {
                value: null,
                squash: true
            },
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.displayName}}'
        },
        data: {
            febelcoCustomer: false
        },
        title: function title($resolve) {
            return $resolve.product.displayName;
        }
    });
}]).component('product', _detail.productDetailComponent).component('productNews', _news.productNewsComponent).component('includedProductsInPack', _includedProductsInPack.includedProductsInPackComponent).component('includedProductsInPanacee', _includedProductsInPanacee.includedProductsInPanaceeComponent).component('productDetailContent', _productDetailContent.productDetailContentComponent).component('productImg', _productImg.productImageComponent).component('productInfo', _productInfo.productInfoComponent).component('productInfoBox', _productInfoBox.productInfoBoxComponent).component('relatedProducts', _relatedProducts.relatedProductsComponent).component('productFilters', _productFilters.productFiltersComponent).component('productDiscounts', _productDiscounts.productDiscountsComponent).component('productOverview', _productOverview.productOverviewComponent).component('productOverviewToolbar', _productOverviewToolbar.productOverviewToolbarComponent).component('productOverviewGrid', _productOverviewGrid.productOverviewGridComponent).component('productOverviewGridItem', _productOverviewGridItem.productOverviewGridItemComponent).component('panaceeOverviewGrid', _panaceeOverviewGrid.panaceeOverviewGridComponent).component('panaceeOverviewGridItem', _panaceeOverviewGridItem.panaceeOverviewGridItemComponent).component('productOverviewList', _productOverviewList.productOverviewListComponent).component('productOverviewListItem', _productOverviewListItem.productOverviewListItemComponent).component('panaceeOverviewList', _panaceeOverviewList.panaceeOverviewListComponent).component('panaceeOverviewListItem', _panaceeOverviewListItem.panaceeOverviewListItemComponent).component('selectedFilters', _selectedFilters.selectedFiltersComponent).component('stockResponse', _stockResponse.stockResponseComponent).component('addProductsToolbar', _addProductsToolbar.addProductsToolbar).component('medipimInfo', _medipimInfo.medipimInfoComponent).component('productCertificatesOverviewSearch', _productCertificatesOverviewSearch.productCertificatesOverviewSearchComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/product/index.js
// module id = 985
// module chunks = 0